<script>
	import { fly, scale } from 'svelte/transition';
    import { sineOut } from "svelte/easing";
    import {
        Button as Button,
        Col,
        Container,
        Icon,
        Row,
        Tooltip
    } from "sveltestrap"
    import { Button as MButton} from 'svelte-materialify';
    import { _ } from 'svelte-i18n';

    let cards = [{"name" : "Brigitte", "visible" : true}, {"name" : "Carole", "visible" : false}];

    let cardSlideX = 2000;

    const myOut = (el)=>{
  	    return fly(el,{x:-cardSlideX, duration:500})
	}

    function choice(i) {
        cards[i].visible = false;

        if (cards[i + 1])
            cards[i + 1].visible = true;
    }
</script>

<Container fluid>
    <Row>
        <Col lg="4"  md="3" sm="12" xs="12"></Col>
        <Col lg="4" md="6" sm="12" xs="12">
            {#key cards}
                {#each cards as card, i}
                    {#if card.visible}
                        <div class="card text-dark bg-secondary border-secondary profil" id="profile-{i}" in:scale={{ delay: 250, duration: 500, easing: sineOut }} out:myOut>
                            <a href="/">
                                <img src="/img/image.jfif" class="card-img" alt="">
                            </a>
                            <div class="card-body">
                                <Row>
                                    <Col lg="10" md="10" sm="10">
                                        <a href="/" class="text-decoration-none">
                                            <h5 class="text-white">{card.name}</h5>
                                        </a>
                                    </Col>
                                    <Col lg="2" md="2" sm="2">
                                        <Button outline id="serious-score">5/10</Button>
                                        <Tooltip target="serious-score" placement="right">{$_("components.HomeDashboard.scoreSerious")}</Tooltip>
                                    </Col>
                                </Row>
                            </div>
                            <div class="text-center">
                                <MButton id="next" class="grey lighten-3 white-text m-2" fab on:click={()=> {
                                    cardSlideX = 2000;
                                    choice(i);
                                }}>
                                    <Icon name="x-lg" />
                                </MButton>
                                <Tooltip target="next" placement="top">{$_("components.HomeDashboard.next")}</Tooltip>

                                <MButton id="ox" size="x-small" class="yellow accent-4 white-text m-2" fab on:click={()=> {
                                    cardSlideX = -2000;
                                    choice(i);
                                }}>
                                    <Icon name="star-fill" />
                                </MButton>
                                <Tooltip target="ox" placement="top">{$_("components.HomeDashboard.ox")}</Tooltip>

                                <MButton id="love" class="red accent-3 white-text m-2" fab on:click={()=> {
                                    cardSlideX = -2000;
                                    choice(i);
                                }}>
                                    <Icon name="heart-fill" />
                                </MButton>
                                <Tooltip target="love" placement="top">{$_("components.HomeDashboard.love")}</Tooltip>
                            </div>
                        </div>
                    {/if}
                {/each}
            {/key}
        </Col>
        <Col lg="4"  md="3" sm="12" xs="12"></Col>
    </Row>
</Container>
